import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { niceDate } from '../util/date';

import "./Home.css"

function Token (props){
    const [idToken, setIdToken] = useState('default');

    async function getToken() {
        const accessTokenRequest = {
          scopes: ["openid"],
          account: props.account,
        };
        const response = await props.instance.acquireTokenSilent(accessTokenRequest);
        console.log('response', response);
        setIdToken(response.idToken);
        return `Bearer ${await response.idToken}`;  
      }    



    useEffect(() => {   
        getToken()  
    }, [props.idToken]); 

    return (        
        <div className='pt-2 pb-3'>
            <h1>Token</h1>
            <div className="ag-theme-alpine" >
                {idToken}
            </div>
        </div>                
    )
}

export default Token;